import joi from 'joi';
import { dates } from 'utils';

export const timestampSchema = joi.number().default(dates.createTimestamp());
